import { useEffect, useState } from "react";
import { useInView } from "../hooks/useInView";

// Animated counter that counts once when scrolled into view.
export default function Counter({ end = 100, duration = 1800, suffix = "" }) {
  const { ref, inView } = useInView({ threshold: 0.4 });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const from = 0;
    const to = end;
    const ease = (t) => 1 - Math.pow(1 - t, 3); // easeOutCubic

    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const v = from + (to - from) * ease(p);
      setValue(v);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, duration]);

  // Format value smartly: keep decimals only if end has decimals
  const display = Number.isInteger(end)
    ? Math.round(value).toLocaleString()
    : value.toFixed(2);

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
}
